import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { HOLIDAY_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_HOLIDAYS } = HOLIDAY_ROUTE;

export const holidayApi = createApi({
  reducerPath: 'holiday',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getHolidays: builder.query({
      query: (data) => ({
        url: `${GET_HOLIDAYS}${buildQueryString(data)}`,
        method: GET
      })
    }),
    getHolidayById: builder.query({
      query: (id) => ({
        url: `${GET_HOLIDAYS}/${id}`,
        method: GET
      })
    }),
    addHoliday: builder.mutation({
      query: (data) => ({ url: `${GET_HOLIDAYS}`, method: POST, data })
    }),
    deleteHoliday: builder.mutation({
      query: (id) => ({
        url: `${GET_HOLIDAYS}/${id}`,
        method: DELETE
      })
    }),
    editHoliday: builder.mutation({
      query: (data) => ({
        url: `${GET_HOLIDAYS}/${data.id}`,
        method: PUT,
        data: data?.data
      })
    })
  })
});

export const {
  useGetHolidaysQuery,
  useGetHolidayByIdQuery,
  useAddHolidayMutation,
  useDeleteHolidayMutation,
  useEditHolidayMutation
} = holidayApi;
